import { makeAutoObservable } from 'mobx'
import type { IChatbotSettings } from '../type'

export class ChatbotInstructions {
  instructions = ''

  constructor() {
    makeAutoObservable(this)
  }

  setInstructions = (value: string) => {
    this.instructions = value
  }

  syncOrigin(settings?: IChatbotSettings | null) {
    this.instructions = settings?.instructions?.value ?? ''
  }

  toJSON(): Pick<IChatbotSettings, 'instructions'> {
    return {
      instructions: this.instructions ? { value: this.instructions } : null,
    }
  }
}
